import { useNavigate } from "react-router-dom"

function ImplementoDetalhe() {
    const navigate = useNavigate();
    const handleOnClickVotlar = () => {
        navigate("/portal/implementos");
    }
    return (
        <div>
            <button onClick={() => handleOnClickVotlar()}>Voltar</button>
            ImplementoDetalhe
        </div>
    )
}

export default ImplementoDetalhe
